enum ModalsTranslationVariant {
  licenseExpiredClickAway1 = 'licenseExpiredClickAway1',
  licenseExpiredClickAway2 = 'licenseExpiredClickAway2',
  licenseExpired = 'licenseExpired',
  licensePurchase = 'licensePurchase',
  licenseNoThanksClickAway = 'licenseNoThanksClickAway',
  licenseNoThanksWorkbook = 'licenseNoThanksWorkbook',
  prekittExpired = 'prekittExpired',
  getFull = 'getFull',
  interactiveStudent = 'interactiveStudent',
  digitalTeacher = 'digitalTeacher',
  digitalMatMan = 'digitalMatMan',
  multimedia = 'multimedia',
  updatedPreKittTitle = 'updatedPreKittTitle',
  updatedPreKittDescription = 'updatedPreKittDescription',
  clickToRefresh = 'clickToRefresh',
  daysRemaining = 'daysRemaining',
  freeTrialExpired = 'freeTrialExpired',
  getMoreTime = 'getMoreTime',
  trialNoThanksClickAway = 'trialNoThanksClickAway',
  trialNoThanksWorkbook = 'trialNoThanksWorkbook',
  trialLogout = 'trialLogout',
  trialNoThanksTrial = 'trialNoThanksTrial',
  trialClassroomPurchase = 'trialClassroomPurchase',
  trialContact = 'trialContact',
  dontShow = 'dontShow',
  shareColleagues = 'shareColleagues',
  survey = 'survey',
  scheduleCall = 'scheduleCall',
  scheduleCallDescription = 'scheduleCallDescription',
  freeDays = 'freeDays',
  welcome = 'welcome',
  welcomeToIDTT = 'welcomeToIDTT',
  blueButton = 'blueButton',
  limitedAccessTitle = 'limitedAccessTitle',
  trialWelcome = 'trialWelcome',
  refresh = 'refresh',
  tooltipsSubmit = 'tooltipsSubmit',
  teachingOrderDetails = 'teachingOrderDetails',
  teachingOrderAreYouSure = 'teachingOrderAreYouSure',
  teachingOrderBackToManage = 'teachingOrderBackToManage',
  teachingOrderUseTeachingOrder = 'teachingOrderUseTeachingOrder',
  editTeachingOrderTitle = 'editTeachingOrderTitle',
  editTeachingOrderBackToManage = 'editTeachingOrderBackToManage',
  editTeachingOrderLabelTitle = 'editTeachingOrderLabelTitle',
  editTeachingOrderYesRename = 'editTeachingOrderYesRename',
  yesDeleteTeachingOrder = 'yesDeleteTeachingOrder',
  deleteTeachingOrderAreYouSure = 'deleteTeachingOrderAreYouSure',
  deleteTeachingOrderDescription = 'deleteTeachingOrderDescription',
  yesRemove = 'yesRemove',
  cancel = 'cancel',
  removeAll = 'removeAll',
  removeAllActivities = 'removeAllActivities',
  activities = 'activities',
  removeAllDescription1 = 'removeAllDescription1',
  removeAllDescription2 = 'removeAllDescription2',
  addActivity = 'addActivity',
  tags = 'tags',
  type = 'type',
  category = 'category',
  activity = 'activity',
  lwtLibrary = 'lwtLibrary',
  hwtResources = 'hwtResources',
  myPortfolio = 'myPortfolio',
  pinnedResources = 'pinnedResources',
  noAssignmentDetails = 'noAssignmentDetails',
  unassignDetails = 'unassignDetails',
  yesUnassign = 'yesUnassign',
  areYouSureUnassign = 'areYouSureUnassign',
  watchVideo = 'watchVideo',
  skipVideo = 'skipVideo',
  downloadFile = 'downloadFile',
  cannotEdit = 'cannotEdit',
  assignmentStartedDescription = 'assignmentStartedDescription',
  assignmentStartedDescription2 = 'assignmentStartedDescription2',
  removeLessonTitle = 'removeLessonTitle',
  removeLessonDescription = 'removeLessonDescription',
  removeAndCreate = 'removeAndCreate',
  tellUsWhenToBegin = 'tellUsWhenToBegin',
  tourStartDateDetails = 'tourStartDateDetails',
  setStartDate = 'setStartDate',
  waitThisIsImportant = 'waitThisIsImportant',
  noActivitiesInAssignment = 'noActivitiesInAssignment',
  schoolStartDate = 'schoolStartDate',
  test22 = 'test22',
  learnMoreFromOurWebsite = 'learnMoreFromOurWebsite',
  learnMore = 'learnMore',
  clearFilters = 'clearFilters',
  clickHere = 'clickHere'
}

export default ModalsTranslationVariant;
